export default "__VITE_ASSET__7azdV2dj__"